import { api, setToken, getToken, clearToken } from "@/lib/api";

const USER_KEY = "labor_public_user";

export const saveUser = (u) => {
  localStorage.setItem(USER_KEY, JSON.stringify(u));
  try { window.dispatchEvent(new CustomEvent("labor-auth-changed", { detail: u })); } catch {}
};
export const getUser = () => { try { return JSON.parse(localStorage.getItem(USER_KEY) || "null"); } catch { return null; } };
export const clearUser = () => {
  localStorage.removeItem(USER_KEY);
  try { window.dispatchEvent(new CustomEvent("labor-auth-changed", { detail: null })); } catch {}
};

export const register = async (data) => {
  const r = await api.post("/users/register", data);
  setToken(r.data.token);
  saveUser(r.data.user);
  return r.data.user;
};

export const login = async (email, password) => {
  const r = await api.post("/users/login", { email, password });
  setToken(r.data.token);
  saveUser(r.data.user);
  return r.data.user;
};

export const refreshMe = async () => {
  try {
    const r = await api.get("/users/me");
    saveUser(r.data);
    return r.data;
  } catch { return null; }
};

export const logout = () => { clearToken(); clearUser(); };

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const loginWithGoogle = () => {
  const redirectUrl = window.location.origin + "/profilo";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export const exchangeGoogleSession = async (sessionId) => {
  const r = await api.post("/auth/google/session", null, {
    headers: { "X-Session-ID": sessionId }
  });
  setToken(r.data.token);
  saveUser(r.data.user);
  return r.data.user;
};

export const getUserHistory = async () => {
  const r = await api.get("/users/history");
  return r.data;
};

export const getUserBookings = async () => {
  const r = await api.get("/user/bookings");
  return r.data;
};

export const getPackages = async () => {
  const r = await api.get("/packages");
  return r.data.packages;
};

export const startCheckout = async (packageId) => {
  const r = await api.post("/payments/checkout", {
    package_id: packageId,
    origin_url: window.location.origin,
  });
  return r.data;
};

export const getUrgencyTickets = async () => {
  const r = await api.get("/urgency-tickets/today");
  return r.data;
};

export const setPin = async (pin) => {
  const r = await api.post("/users/set-pin", { pin });
  return r.data;
};

export const pinLogin = async (email, pin) => {
  const r = await api.post("/users/pin-login", { email, pin });
  setToken(r.data.token);
  saveUser(r.data.user);
  return r.data.user;
};
